import moment from "moment";

export const rowPerPage = 50;
export const antTableScroll = { x: true };
export const addFormType = "Add";
export const editFormType = "Edit";

export const transactionTypeList = [
  { id: "All", title: "Select All" },
  { id: "0", title: "Pending" },
  { id: "1", title: "Success" },
  { id: "2", title: "Failed" },
  { id: "3", title: "Refund" },
];

export const statusTypeList = [0, 1, 2, 3];
export const statusTypeList1 = [0, 1, 2, 3, 4];
export const liveStatusTypeList = [-1, 0, 1, 2, 3];
export const currentYears = moment().format("YYYY");

export const defaultSiteLogo = "assets/img/logo.png";
export { default as Mainlogo } from "../../assets/images/logos/logo.png";
export { default as pendingIcon } from "../../assets/images/icons/pending1.jpg";
export { default as suceessIcon } from "../../assets/images/icons/success.png";
export { default as failedIcon } from "../../assets/images/icons/failed2.jpg";
export { default as verifyIcon } from "../../assets/images/2601778.png";
export { default as processingIcon } from "../../assets/images/icons/processing.png";

export const templateDefault = "DEFAULT";
export const templateOne = "TEMPLATE1";
export const templateTwo = "TEMPLATE2";
export const templateThree = "TEMPLATE3";

export const defaultSiteName = "Aakshar Digital Technology Pvt.Ltd";
export const defaultSiteName1 = "Jan Paisa";
export const projectName = "Janpaisa";
export const defaultSiteAddress =
  "Jain shree Computer near Paras Hospital Teen Gulli ke pass Damoh MP Bharat 470661";
export const defaultSiteAddress1 =
  "Branch- Bhopal, New Dehli";

// export const defaultSiteContact = "9205844811,9205844822,9205844833";
export const defaultEMail = "info@janpaisa.in";
export const supportEMail = "info@janpaisa.in";
export const conatctEMail = "info@janpaisa.in";
export const defaultSiteDomain = "janpaisa.in";
export const defaultSiteDomain1 = "https://janpaisa.in/";
export const defaultContact1 = "8982919238";
export const defaultSiteColor = "#fff";
export const defaultMenuColor = "#0a165e";
export const defaultButtonColor = "#9e2a96";
export const defaultDashboardMenuColor = "#000";
export const defaultDashboardButtonColor = "#6f0d5b";

export const baseB4Key = (type = "jpeg") => `data:image/${type};base64,`;

export const getTodayDate = () => {
  const date = new Date().toISOString().split("T")[0];
  return date;
};

export const noImage = "../assets/images/no-image.jpg";
export const base64Key = "data:image/jpeg;base64,";

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

async function handleAllImagesUpLoad(file) {
  const base64 = await convertToBase64(file);
  // console.log('base64---', base64)
  const base642 = base64.split(",");
  return base642[1];
}
export default handleAllImagesUpLoad;

export const urlForInputFile = (file) => URL.createObjectURL(file);

export function splitImageBaseData(data) {
  const base642 = data.split(",");
  return base642[1];
}

export const consoleEnableKey = "CONSOLE_ENABLE";
export const appConfigKey = [
  // 'LOGIN_ENABLE',
  consoleEnableKey,
  "FUNDTRANSFER_TIME",
  "LOGIN_TIME",
  "TWO_FACTOR_AUTHENTICATE",
  "SMS_ENABLE",
  "SMS_SEND_USER_DETAILS",
  "SMS_TRANSACTION_MESSAGE",
  "SMS_RECHARGE_MESSAGE",
  "SMS_MODE_ENABLE",
  "MOBILE_NO_LOGIN",
  "UNDER_MAINTENANCE",
  "Scheduler",
  "SchedulerBatch",
  "LIMIT_SERVICE_SWITCH_BBPS",
  "LIMIT_SERVICE_SWITCH_DMT",
  "LIMIT_SERVICE_SWITCH_PAYOUT",
  "LIMIT_SERVICE_SWITCH_RECHARGE",
  // 'ROLEWISE_SERVICE_ENABLE'
  "TRANSACTION_STATUS_CHECK_DELAY"
];

export const roleList = {
  0: "User",
  1: "Admin",
  2: "Business",
  3: "Master Distributor",
  4: "Super Distributor",
  5: "Distributor",
  6: "Retailer",
  7: "Employee",
};

export const popButtonDefaultIcon = (
  <i className="bi bi-question-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonDefaultTitile = "Confirmation";
export const popButtonDefaultDesc = (val = "") =>
  `Are you sure to ${val || "perform this action"}.`;
export const popButtonStatusIcon = (
  <i className="bi bi-exclamation-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonStatusTitile = "Change Status";
export const popButtonStatusDesc = (val = "") =>
  `Are you sure to change ${val || "this data"} status.`;
export const popButtonDeleteIcon = (
  <i className="bi bi-question-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonDeleteTitile = "Delete data";
export const popButtonDeleteDesc = (val = "") =>
  `Are you sure to delete ${val || "this data"}.`;
export const popupDeleteBtnType = { danger: true, type: "link" };

export const ellipsisLast = (data, limit = 1, fromWhere = "last") => {
  if (data && data.length > limit) {
    if (fromWhere === "last") {
      return `${data.substring(0, limit)}...`;
    }
    if (fromWhere === "start") {
      return `...${data.substring(data.length - limit, limit)}`;
    }
  }
  return data;
};

export const ellipsisButtonTitle = "View More";

export const ticketTypeKey = "TICKETTYPE";
export const ticketCategoryKey = "TICKETCATEGORY";
export const ticketSubjectKey = "TICKETSUBJECT";
export const ticketProjectKey = "TICKETPROJECT";
export const byMeKey = "By Me";

export const ticketStatusList = [
  { id: 0, value: 0, title: "Pending", label: "Pending" },
  { id: 1, value: 1, title: "Resolved", label: "Resolved" },
  { id: 2, value: 2, title: "InProgress", label: "InProgress" },
  { id: 3, value: 3, title: "Hold", label: "Hold" },
  { id: 4, value: 4, title: "Reject", label: "Reject" },
  { id: 5, value: 5, title: "In User Review", label: "In User Review" },
  // {id: 5, title: 'Cancel'},
];

export const apiDocKeysList = [
  "APIDOC_RechargeAccess",
  "APIDOC_BillPayAccess",
  "APIDOC_PayoutAccess",
  "APIDOC_UPIPayoutAccess",
  "APIDOC_CreditCard",
  // "apidoC_PayIn"
  "APIDOC_PayIn",
];

export const ConvertToIndianRupessFormat = (val) => {
  const parts = parseFloat(val).toFixed(2).split(".");
  let integerPart = parts[0];

  // Handle Indian-style commas
  const lastThree = integerPart.slice(-3);
  const otherDigits = integerPart.slice(0, -3);

  if (otherDigits !== "") {
    integerPart =
      otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
  }

  return integerPart + "." + parts[1];
};

export const rateTypeList = [
  {
    title: "Percentage",
    label: "Percentage",
    value: 1,
    id: 1,
  },
  {
    title: "Flat",
    label: "Flat",
    value: 0,
    id: 0,
  },
];

export const rateTypeObject = {
  0: "Flat",
  1: "Percentage",
};

export const reverseRateTypeObject = {
  Flat: 0,
  Percentage: 1,
};

export const adminRole = 1;
export const businessRole = 2;
export const masterDistributorRole = 3;
export const superDistributorRole = 4;
export const distributorRole = 5;
export const retailerRole = 6;
export const employeeRole = 7;
export const superAdminRole = 8;
export const maxUserListRole = masterDistributorRole

export const roleToSeniour = {
  [employeeRole]: adminRole,
  [businessRole]: adminRole,
  [masterDistributorRole]: adminRole,
  [superDistributorRole]: masterDistributorRole,
  [distributorRole]: superDistributorRole,
  [retailerRole]: distributorRole,
};

export const roleToJuniour = {
  [adminRole]: masterDistributorRole,
  [masterDistributorRole]: superDistributorRole,
  [superDistributorRole]: distributorRole,
  [distributorRole]: retailerRole,
};

export const roleByKey = {
  admin: adminRole,
  business: businessRole,
  masterDistributor: masterDistributorRole,
  superDistributor: superDistributorRole,
  distributor: distributorRole,
  retailer: retailerRole,
  employee: employeeRole,
  superAdmin: superAdminRole,
};

export const userRoleList = {
  admin: "Admin",
  business: "Business Partner",
  masterDistributor: "Master Distributor",
  superDistributor: "Super Distributor",
  distributor: "Distributor",
  retailer: "Retailer",
  employee: "Employee",
  superAdmin: "Super Admin",
};

export const userRoleListByRole = {
  [adminRole]: "Admin",
  [businessRole]: "Business Partner",
  [masterDistributorRole]: "Master Distributor",
  [superDistributorRole]: "Super Distributor",
  [distributorRole]: "Distributor",
  [retailerRole]: "Retailer",
  [employeeRole]: "Employee",
  [superAdminRole]: "Super Admin",
};

export const filterRole = (userRole = 0) => {
  return userRole === masterDistributorRole
    ? superDistributorRole
    : userRole === superDistributorRole
    ? distributorRole
    : retailerRole;
};

export const dateFormat = "YYYY-MM-DD";
export const dateFormat1 = "MMM DD YYYY";
export const dateTime24Format = "MMM DD YYYY, HH:mm";
export const dateTime24sFormat = "MMM DD YYYY, HH:mm:ss";
export const date_Time24sFormat = "YYYY-MM-DD HH:mm:ss";
export const date_Time12Format = "YYYY-MM-DD hh:mm A";
export const date_Time12sFormat = "YYYY-MM-DD hh:mm:ss A";
export const date_r_Time24sFormat = "DD-MM-YYYY HH:mm:ss";
export const date_r_Time12sFormat = "DD-MM-YYYY HH:mm:ss A";
export const date_s_Time24sFormat = "DD/MM/YYYY HH:mm:ss";
export const date_s_Time24sFormat1 = "MM/DD/YYYY HH:mm:ss";
export const date_s_Time12sFormat = "DD/MM/YYYY hh:mm:ss A";
export const date_s_Time12sFormat1 = "MM/DD/YYYY hh:mm:ss A";
export const dateTime12Format = "MMM DD YYYY, hh:mm A";
export const dateTime12Format1 = "MMM DD YYYY, hh:mmA";
export const dateTime12sFormat = "MMM DD YYYY, hh:mm:ss A";

export const transectionCDType = [
  {
    id: "credit",
    title: "credit",
  },
  {
    id: "debit",
    title: "debit",
  },
];

export const nameTitleList = [
  { id: 0, title: "Female" },
  { id: 1, title: "Male" },
];

export const allStatusList = [-1, 0, 1, 2, 3, 4];

export const allRoleList = [1, 2, 3, 4, 5, 6];

export const reciptTitle = {
  BE: "Balance Enquiry Receipt",
  CW: "Cash Withdrawal Receipt",
  M: "Aadhar Pay Receipt",
  MS: "Mini Statement Receipt",
  CD: "Cash Deposit Receipt",
  balance_enquiry: "Balance Enquiry Receipt",
  cash_withdrawal: "Cash Withdrawal Receipt",
  aadhar_pay: "Aadhar Pay Receipt",
  mini_statement: "Mini Statement Receipt",
};
